module.exports = __webpack_public_path__ + "static/leo-tucker.6384102e.webp";